import { render } from "./EditRun.vue?vue&type=template&id=48255549&scoped=true&ts=true"
import script from "./EditRun.vue?vue&type=script&lang=ts"
export * from "./EditRun.vue?vue&type=script&lang=ts"

import "./EditRun.vue?vue&type=style&index=0&id=48255549&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48255549"]])

export default __exports__